import { render, staticRenderFns } from "./UserPointHistory.vue?vue&type=template&id=19cc8158&lang=html"
import script from "./UserPointHistory.vue?vue&type=script&lang=js"
export * from "./UserPointHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports